module.exports = __webpack_public_path__ + "static/03-6430dbea65bb0f3b6999f6b4e75c8262.jpg";